var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuid } from 'uuid';
import TENANT_ID from '../../config/TenantId';
import asyncStorageProvider from '../../persisted/usePersistedObject/asyncStorageProvider';
import StorageKey from '../../persisted/usePersistedObject/StorageKey';
export const ANONYMOUS_DEVICE_ID_STORAGE_KEY = StorageKey(TENANT_ID, 'anonymousDeviceId');
export const MAX_ID_LENGTH_SUPPORT_BY_WEBLAB = 30;
const DeviceInfoProvider = {
    getAnonymousDeviceId: () => __awaiter(void 0, void 0, void 0, function* () {
        const { getWithKey, setWithKey } = asyncStorageProvider();
        let anonymousDeviceId = yield getWithKey(ANONYMOUS_DEVICE_ID_STORAGE_KEY);
        if (!anonymousDeviceId) {
            anonymousDeviceId = uuid().substring(0, MAX_ID_LENGTH_SUPPORT_BY_WEBLAB);
            yield setWithKey(ANONYMOUS_DEVICE_ID_STORAGE_KEY, anonymousDeviceId);
        }
        return anonymousDeviceId;
    }),
};
export default DeviceInfoProvider;
//# sourceMappingURL=DeviceInfoProvider.js.map